import {parseJwtFromToken} from '../utils';
import {walletPost} from './walletAxios';
import {
    LOGIN_PATH,
    LOCAL_STORAGE_ACCESS_TOKEN_KEY,
    LOCAL_STORAGE_FINANCIAL_USER_ID_KEY,
    LOCAL_STORAGE_REFRESH_TOKEN_KEY,
    LOCAL_STORAGE_USER_ID_KEY,
    REFRESH_PATH,
} from './authConstants';

export {
    AUTH_PATH,
    LOGIN_PATH,
    REFRESH_PATH,
    LOCAL_STORAGE_ACCESS_TOKEN_KEY,
    LOCAL_STORAGE_REFRESH_TOKEN_KEY,
    LOCAL_STORAGE_FINANCIAL_USER_ID_KEY,
    LOCAL_STORAGE_USER_ID_KEY,
} from './authConstants';

export const refreshToken = async (
    token = localStorage.getItem(LOCAL_STORAGE_REFRESH_TOKEN_KEY)
) => {
    return walletPost(`${REFRESH_PATH}?refreshToken=${token}`, undefined, false)
        .then(response => {
            saveAuthData(response);
            return response;
        });
};

export const loginByUserName = async (username, password) => {
    return walletPost(LOGIN_PATH, {login: username, password}, false)
        .then(response => {
            saveAuthData(response);
            return response;
        });
};

function saveAuthData(response) {
    if (!response?.accessToken) return;

    localStorage.setItem(LOCAL_STORAGE_ACCESS_TOKEN_KEY, response.accessToken);
    localStorage.setItem(LOCAL_STORAGE_REFRESH_TOKEN_KEY, response.refreshToken);

    const tokenData = parseJwtFromToken(response.accessToken);
    tokenData.financialUserId &&
        localStorage.setItem(LOCAL_STORAGE_FINANCIAL_USER_ID_KEY, tokenData.financialUserId);
    tokenData.userId &&
        localStorage.setItem(LOCAL_STORAGE_USER_ID_KEY, tokenData.userId);
}